import Layout from "./layout";

const Loader = () => (
  <Layout className="justify-center">
      <div className="dot-typing" />
  </Layout>
);

export default Loader;
